type Props = {
  tagName: string;
};

export function Tag(props: Props) {
  const { tagName } = props;

  return (
    <div
      className='inline-flex items-center justify-start gap-3 rounded-[78px] bg-azure-595/10 px-4 py-[5px]'
      // style="display: inline-flex !important; align-items: center !important; justify-content: flex-start !important; gap: 0.75rem !important; border-radius: 78px !important; background-color: rgba(5, 135, 251, 0.1) !important; padding: 5px 1rem !important; margin: 0 !important;"
    >
      <p
        className='font-["Poppins"] text-base leading-snug font-semibold text-azure-595'
        // style="font-family: 'Poppins' !important; font-size: 1rem !important; font-weight: 600 !important; line-height: 1.375 !important; color: #0587FB !important; margin: 0 !important; text-decoration: none !important;"
      >
        {tagName}
      </p>
    </div>
  );
}
